// ** UI
import Box from '@mui/material/Box';

// ** Components
import SearchSectionInput from './SearchSectionInput';
import SearchSectionSelect from './SearchSectionSelect';

// ** Types
import type { SearchSectionProps } from './types';

const SearchSection = ({
	categoryOptions,
	periodOptions,
	selectedCategory,
	selectedPeriod,
	searchTerm,
	isLoading = false,
	categoryPlaceholder = 'Themenfilter',
	periodPlaceholder = 'Monate',
	searchPlaceholder = 'Suchen...',
	backgroundColor,
	onCategoryChange,
	onPeriodChange,
	onSearchChange,
	onSearchSubmit,
	showCategory = true,
	showPeriod = true,
	showSearch = true
}: SearchSectionProps) => {
	const isVisible = showCategory || showPeriod || showSearch;

	if (!isVisible) return null;

	return (
		<Box
			role="search"
			aria-busy={isLoading}
			sx={{
				display: 'grid',
				gridTemplateColumns: {
					xs: '1fr',
					md: '1fr 1fr',
					lg: '2fr 1fr minmax(0, 1fr)'
				},
				columnGap: { xs: 0, md: 2.75, lg: 4.5 },
				rowGap: 0
			}}
		>
			{showCategory && (
				<SearchSectionSelect
					id="search-section-category-filter"
					value={selectedCategory}
					placeholder={categoryPlaceholder}
					options={categoryOptions}
					disabled={isLoading}
					backgroundColor={backgroundColor}
					onChange={onCategoryChange}
				/>
			)}

			{showPeriod && (
				<SearchSectionSelect
					id="search-section-period-filter"
					value={selectedPeriod}
					placeholder={periodPlaceholder}
					options={periodOptions}
					disabled={isLoading}
					backgroundColor={backgroundColor}
					onChange={onPeriodChange}
					sx={{ mt: { xs: 6, md: 0 } }}
				/>
			)}

			{showSearch && (
				<SearchSectionInput
					id="search-section-input"
					value={searchTerm}
					placeholder={searchPlaceholder}
					disabled={isLoading}
					onChange={onSearchChange}
					onSubmit={onSearchSubmit}
					sx={{
						gridColumn: { md: '1 / -1', lg: 'auto' },
						mt: { xs: 12, md: 6, lg: 0 },
						ml: { lg: 1 }
					}}
				/>
			)}
		</Box>
	);
};

export default SearchSection;
